import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'fl-not-authorized',
  imports: [CardModule, ButtonModule, RouterModule],
  templateUrl: './not-authorized.component.html',
})
export class NotAuthorizedComponent {
  private router = inject(Router);

  goToHome = (): void => {
    this.router.navigate(['/home']);
  };
}
